<template>
  <div class="canvas" :class="{ visible: isVisible }" ref="target" id="canvas">
    <NuxtParticles
      v-if="isVisible"
      id="tsparticles"
      :options="options"
    />
  </div>
  <div id="slider" :class="{ svet }">
    <UiBg class="slide slide1" src="/static/image/slide1.png" />
    <UiBg class="slide slide2" src="/static/image/slide2.png" />
  </div>
</template>

<script setup>
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);
const svet = ref(false);
const to = ref();

const light = (p) => {
  svet.value = !svet.value;
  let delay = 0;
  switch (p) {
    case 3:
      delay = 1500;
      break;
    case 4:
      delay = 2000;
      break;
    case 5:
      delay = 2000;
      break;
    case 6:
      delay = 2000;
      break;
    default:
      delay = 200;
      break;
  }
  p++;
  if (p == 6) p = 0;
  to.value = setTimeout(() => light(p), delay);
};
//light(0);
const options = {
  particles: {
    number: {
      value: 100,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: {
      value: "#ffffff",
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#000000",
      },
      polygon: {
        nb_sides: 5,
      },
      image: {
        src: "img/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 3,
      random: true,
      anim: {
        enable: false,
        speed: 40,
        size_min: 0.1,
        sync: false,
      },
    },
    line_linked: {
      enable: false, // line
      distance: 150,
      color: "#ffffff",
      opacity: 0.4,
      width: 1,
    },
    move: {
      enable: true,
      speed: 2,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: {
        enable: true,
        mode: "repulse",
      },
      onclick: {
        enable: true,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 140,
        line_linked: {
          opacity: 1,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: true,
};
watch(isVisible, async (n) => {
  if (n) light(0);
  else {
    svet.value = false;
    clearTimeout(to.value);
  }
});
</script>
